var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-wrap',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"preview-data":_vm.previewData}},[_c('div',{attrs:{"id":"x-spreadsheet"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }